// extracted by mini-css-extract-plugin
export default {"projects-navigation":"sMX937eRBWfJj70TTS7g","create-button":"USMwaNwJAdEK5Fe2mjIY","package-label":"qIhShTkMFWJ0JI6jihiL"};